<template>
    <v-list class="nx-selectable-list" ref="list">
      <nx-selectable-list-item
        :key="item.id"
        :sortable="sortable"
        @input="$emit('input', item)"
        @option="$emit($event, item)"
        v-bind="item"
        v-for="item in items"
      ></nx-selectable-list-item>
    </v-list>
</template>

<script>
import Sortable from 'sortablejs';
import SortableListItem from '@/components/list/legacy/SelectableListItem';

export default {
  name: 'nx-selectable-list',
  extends: {},
  mixins: [],
  components: {
    [SortableListItem.name]: SortableListItem,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    hasMoreItems: {
      type: Boolean,
      default: false,
    },
    sortable: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    sortablejs: false,
  }),
  computed: {},
  watch: {},
  methods: {
    remove() {
    },
    update(e) {
      this.$emit('move', {
        from: e.oldIndex,
        to: e.newIndex,
      });
    },
  },
  mounted() {
    if (this.items && this.sortable && !this.sortablejs) {
      this.sortablejs = Sortable.create(this.$refs.list.$el, {
        handle: '.nx-drag-handle',
        onUpdate: this.update,
      });
    }
  },
};
</script>
